import { IFileWithAttachRequest } from '../interfaces/fileWithAttachRequest';
import { IShadowStorageFileAttach } from '../interfaces/shadowStorageFileAttach';

export class FileWithAttachRequest implements IFileWithAttachRequest {
    idFile: number;
    public idAttachType: number;
    chiamataPreAdesioneDateTime: Date;

    constructor(fa?: IFileWithAttachRequest) {
        if (fa == null) {
            fa = {} as IFileWithAttachRequest;
        }
        this.idFile = fa.idFile;
        this.idAttachType = fa.idAttachType;
        this.chiamataPreAdesioneDateTime = fa.chiamataPreAdesioneDateTime;
    }

    static FromShadowStorageFileAttach(ssfa: IShadowStorageFileAttach): FileWithAttachRequest {
        return new FileWithAttachRequest({
            idFile: ssfa.id,
            idAttachType: ssfa.idAttachType,
            chiamataPreAdesioneDateTime: ssfa.chiamataPreAdesioneDateTime
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/models/request-and-responses/rest-api/classes/fileWithAttachRequest.ts